import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { formatNumber, formatResponseTime } from '../../constants/nginx-sites';
import { cn } from '../../lib/utils';

interface SummaryKpiCardsProps {
  totalRequests: number;
  totalVisitors: number;
  totalPageViews: number;
  avgErrorRate?: number;
  avgResponseTime?: number | null;
}

export function SummaryKpiCards({
  totalRequests,
  totalVisitors,
  totalPageViews,
  avgErrorRate,
  avgResponseTime,
}: SummaryKpiCardsProps) {
  const errorRateColor =
    avgErrorRate === undefined
      ? ''
      : avgErrorRate < 2
        ? 'text-green-600 dark:text-green-400'
        : avgErrorRate <= 5
          ? 'text-amber-500 dark:text-amber-400'
          : 'text-red-600 dark:text-red-400';

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Total de Requisições
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{formatNumber(totalRequests)}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Visitantes Únicos
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{formatNumber(totalVisitors)}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">Page Views</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{formatNumber(totalPageViews)}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Taxa de Erro Média
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className={cn('text-2xl font-bold', errorRateColor)}>
            {avgErrorRate !== undefined ? `${avgErrorRate.toFixed(1)}%` : '-'}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Tempo de Resposta Médio
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {avgResponseTime != null ? formatResponseTime(avgResponseTime) : '-'}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
